
// const list = ['bel', 'build', 'flect', 'imagine']

export let dictionary = {
    rachelknox: {
        offsets: {
            lineup: ['-20%',0],
            detail: ['-20%',0]
        },
        name: 'Rachel<br/>Knox, M.D.',
        image: '/images/lineup/speaker-rachelknox.jpg',
        title: '',
        section: '',
        linkcolor: 'white',
        bio: `Rachel is the co-founder of American Cannabinoid Clinics and Chair of the Oregon Cannabis Commission. She received her medical and business degrees from Tufts University and then pursued additional study of the most important physiologic system in the human body — the endocannabinoid system. She is passionate about educating her professional peers and broader public about the safety and effectiveness of Cannabinoid Medicine. Her work is groundbreaking at a transformative time in our society.`,
    },
    davidpeyton: {
        offsets: {
            lineup: ['-30%',0],
            detail: ['-20%',0]
        },
        name: 'David<br/>Peyton, Ph.D.',
        image: '/images/lineup/speaker-davepeyton.jpg',
        title: '',
        section: '',
        linkcolor: 'white',
        bio: `David is committed to eradicating malaria from the world. With a Ph.D. in chemistry, David joined the faculty at Portland State University with a focus on the structures and motions of complex biological systems. When a collaborator brought to his attention the resurgence of malaria across the globe, he felt compelled to act. With a focus on combining public health and chemistry, he’s recently co-founded DesignMedix, a company designed to bring important drugs to market.`,
    },
    carinekanimba: {
        offsets: {
            lineup: ['-20%',0],
            detail: ['-20%',0]
        },
        name: 'Carine<br/>Kanimba',
        image: '/images/lineup/speaker-carinekanimba.jpg',
        title: '',
        section: '',
        linkcolor: 'white',
        bio: `Carine was born in Kigali, Rwanda shortly before the genocide of 1994. She survived the Rwandan genocide thanks to her adoptive father, Paul Rusesabagina, whose story is portrayed in the movie Hotel Rwanda. Growing up in Belgium and the U.S., Carine completed her undergraduate degree at Northwestern University and masters in Law and Economics from Aix-Marseille University, Erasmus University of Rotterdam, and University of Bologna. Today, Carine works for Flat World Partners, an advisory and investment intermediary focused on impact investing.`,
    },
    tylermalek: {
        offsets: {
            lineup: ['-20%',0],
            detail: ['-20%',0]
        },
        name: 'Tyler<br/>Malek',
        image: '/images/lineup/speaker-tylermalek.jpg',
        title: '',
        section: '',
        bio: `In early 2011, Tyler heard that his cousin Kim Malek was opening an ice cream shop called Salt & Straw. He convinced her to take him on, dropped everything, and moved to Portland. Using an ice cream maker he found at Goodwill, Tyler began his new role as head ice cream maker. He’s created more than 600 flavors with his R&D department and helped change the way America eats. Thanks to him, we’re all a bit saltier. And sweeter. `,
    },
    karyyouman: {
        offsets: {
            lineup: ['-20%',0],
            detail: ['-20%',0]
        },
        name: 'Kary<br/>Youman',
        image: '/images/lineup/speaker-karyyouman.jpg',
        title: '',
        section: '',
        bio: `A marketing maverick with a Screen Actors Guild card in his back pocket, this golf-obsessed Portlander has a hunger for disruption in the digital space. With a passion for kismet connection and understanding, he has committed himself to genealogy, building bridges, and helping people reach for the unknown without fear, judgement, or pretense. `,
    },
    annadebenham: {
        offsets: {
            lineup: ['-20%',0],
            detail: ['-20%',0]
        },
        name: 'Anna<br/>Debenham',
        image: '/images/lineup/speaker-annadebenham.jpg',
        title: '',
        section: '',
        bio: `Anna considers herself a “mental health plumber,” having worked in private practice and multidisciplinary healing and support teams for two decades in the U.S., Australia, and U.K. In 2017, Anna created The Insight Alliance, an organization that works with men and women in the Oregon Correctional System with a simple focus: understanding the limitless nature of the human mind, and recognizing our own innate wellbeing — that everything we need to thrive already exists within us. `,
    },
    nandiniranganathan: {
        offsets: {
            lineup: ['-20%',0],
            detail: ['-20%',0]
        },
        name: 'Nandini<br/>Ranganathan Ph.D.',
        image: '/images/lineup/speaker-nandiniranganathan.jpg',
        title: '',
        section: '',
        linkcolor: 'white',
        bio: `Nandini is the founder and Executive Director of Make+Think+Code, an institute, creative incubator, and technology lab for Portland’s creative, tech, civic, and educational communities to explore imaginative solutions to urgent problems. Nandini has a Ph.D. in Mathematics from the University of Michigan and is deeply passionate about expanding access to cutting-edge technology and design education. She feels a tinge of confusion and sadness checking “I am not a robot” while filling out forms online.`,
    },
    jdhooge: {
        offsets: {
            lineup: ['-20%',0],
            detail: ['-20%',0]
        },
        name: 'JD<br/>Hooge',
        image: '/images/lineup/speaker-jdhooge.jpg',
        title: '',
        section: '',
        bio: `JD is a co-founder & Chief Creative Officer at Instrument, a digital brand and experience innovation company. Instrument’s team of over 200 creative technologists help organizations like Google, Nike, OneMedical, and MercyCorps navigate the complexities of innovation. Twenty years in to his interaction design career — in an era where our digital wellbeing is at risk — JD’s personal mission (and also, Instrument’s mission) is to enrich human lives through the thoughtful application of design and technology.`,
    },
    palomamedina: {
        offsets: {
            lineup: ['-20%',0],
            detail: ['-20%',0]
        },
        name: 'Paloma<br/>Medina',
        image: '/images/lineup/speaker-palomamedina.jpg',
        title: '',
        section: '',
        linkcolor: 'white',
        bio: `Paloma is an expert in the neuroscience behind equity and the psychology on how to improve our work and personal lives. She is a performance coach, trainer, and owner of 11:11 Supply, a store that specializes in beautiful work tools designed to help you feel more productive, happy, and balanced. She has worked with tech companies such as Etsy and Digital Ocean, nonprofit organizations, homeless healthcare clinics, as well as individual leaders and CEOs. `,
    },
    
    steveoldham: {
        offsets: {
            lineup: ['-20%',0],
            detail: ['-20%',0]
        },
        name: 'Steve<br/>Oldham',
        image: '/images/lineup/speaker-steveoldham.jpg',
        title: '',
        section: '',
        bio: `Steve is CEO of Carbon Engineering, a Canadian-based clean energy company. He will give us a hopeful peek into the future and new technology that captures CO₂ directly from the atmosphere and synthesizes it into clean, affordable transportation fuel. Steve played a lead role in a number of ‘Canada firsts’ in technology commercialization, including the first robot performing brain surgery, the first commercial radar satellite, robots that clean the inside of nuclear reactors, and satellites that service and repair other satellites.`,
    },
    xiomaratorres: {
        offsets: {
            lineup: ['-20%',0],
            detail: ['-20%',0]
        },
        name: 'Xiomara<br/>Torres',
        image: '/images/lineup/speaker-xiomaratorres.jpg',
        title: '',
        section: '',
        linkcolor: 'white',
        forcelinkcolor: true,
        bio: `Xiomara Torres crossed the Tijuana River at age 8 for the chance at a better life. Speaking no English, she settled in California and spent time in the foster care system until she aged out at 18. Today she’s gone from undocumented immigrant to recently-elected Multnomah County Judge. She’s spent her career fighting for Oregon’s most vulnerable children and brings her talent and heart forward every day to make life better for our community.`,
    },
    duncancampbell: {
        offsets: {
            lineup: ['-20%',0],
            detail: ['-20%',0]
        },
        name: 'Duncan<br/>Campbell',
        image: '/images/lineup/speaker-duncancampbell.jpg',
        title: '',
        section: '',
        linkcolor: 'white',
        bio: `Duncan’s passion for helping society’s most vulnerable children grew from his own experience in inner city Portland. Duncan founded Friends of the Children, an organization that seeks to break intergenerational cycles of poverty through transformative mentorship. The nonprofit started with 16 children in 1993 and now serves thousands around the country. Duncan is a true champion for children. He holds a B.S. and J.D. from the University of Oregon and enjoys Smokey Robinson concerts, hiking in the wilderness, and spending time with his three children and six grandchildren.`,
    },
    
    
    

    pianopushplay: {
        offsets: {
            lineup: ['-20%',0],
            detail: ['-20%',0]
        },
        name: 'Piano.<br/>Push.<br/>Play.',
        image: '/images/lineup/performer-piano.jpg',
        title: '',
        section: '',
        bio: `Founded by Megan McGeorge, Piano. Push. Play. rescues pianos and places them across the city for everyone to enjoy. Each piano is given new life by artists who paint, fabricate, and even tattoo the surfaces. What began as one piano on one street corner is now a city-wide musical experience that invites people of Portland to create music together. It’s a beautiful expression of togetherness, and their work represents Portland at its creative finest.`,
    },

    rebeccajordansmith: {
        offsets: {
            lineup: ['-20%',0],
            detail: ['-20%',0]
        },
        name: 'Rebecca<br/>Jordan Smith',
        image: '/images/lineup/speaker-rebeccajordansmith.jpg',
        title: '',
        section: '',
        linkcolor: 'white',
        forcelinkcolor: true,
        bio: `A new Portland resident by way of New York, Los Angeles and Cleveland, Rebecca is a former actress and recording artist turned award-winning songwriter, whose original songs have been recorded by Prince, Kelly Clarkson, and John Legend, among others. As a producer and teacher today, she inspires artists, students — and all of us — toward creativity in its many forms.`,
    },

    theportlandcelloproject : {
        offsets: {
            lineup: ['-20%',0],
            detail: ['-20%',0]
        },
        name: 'The Portland<br/>Cello Project ',
        image: '/images/lineup/performer-portlandcelloproject.jpg',
        mobileimage: '/images/lineup/performer-portlandcelloproject-mobile.jpg',
        title: '',
        section: '',
        linkcolor: 'white',
        forcelinkcolor: true,
        bio: `The Portland Cello Project is a nationally-recognized performing, recording, and educational group with a revolving cast of cellists. They appear anywhere and everywhere in North America, from punk rock clubs to symphony halls, from street parties to exclusive private events. Their work builds bridges through education, community outreach, and cross-genre collaboration. Prepare yourself for a fresh take on the cello and a truly unique artistic experience!`,
    },
    nwdanceproject: {
        offsets: {
            lineup: ['-20%',0],
            detail: ['-20%',0]
        },
        name: 'NW Dance<br/>Project',
        image: '/images/lineup/performer-nwdanceproject.jpg',
        mobileimage: '/images/lineup/performer-nwdanceproject-mobile.jpg',
        title: '',
        section: '',
        linkcolor: 'white',
        forcelinkcolor: true,
        bio: `NW Dance Project is dedicated to innovative dance pieces and has fostered nearly 300 original, contemporary works to date — an unparalleled number for a dance company. Their award-winning company performs in Portland and tours nationally and internationally. They’re committed to advancing dance education, equity, and community engagement through cost-free engagement and access programs. From their creative center home in NE Portland, they continue to inspire the Rose City (and beyond) toward beauty, creativity, and connection. `,
    },
    
    
    davidrae: {
        offsets: {
            lineup: ['-20%',0],
            detail: ['-20%',0]
        },
        name: 'David<br/>Rae',
        image: '/images/lineup/speaker-davidrae.jpg',
        title: '',
        section: '',
        linkcolor: 'white',
        forcelinkcolor: true,
        bio: `David believes in creating joy in others through community connection. A former creative at Nike, he is the Co-Founder and President of 503 Media & Events. He was part of the original planning group that brought TEDx to the Rose City in 2009 and has worked tirelessly to grow the event for our city. David formerly served as the Licensee for TEDxPortland and has been the host and emcee since 2012. `,
    },
    lindseymurphy: {
        offsets: {
            lineup: ['-20%',0],
            detail: ['-20%',0]
        },
        name: 'Lindsey<br/>Murphy',
        image: '/images/lineup/speaker-lindseymurphy.jpg',
        title: '',
        section: '',
        bio: `Lindsey is the creator, producer, and host of The Fab Lab with Crazy Aunt Lindsey, YouTube’s #1 kids science web series that takes everyday science concepts and turns them into fabulous DIY projects. As a STEM (Science, Technology, Engineering, Math) advocate and science communicator, Lindsey focuses on accessibility and diversity in STEM. `,
    },
    rennygleeson: {
        offsets: {
            lineup: ['-20%',0],
            detail: ['-20%',0]
        },
        name: 'Renny<br/>Gleeson',
        image: '/images/lineup/speaker-rennygleeson.jpg',
        title: '',
        section: '',
        bio: `Renny is a geek who’s worked in the startup and interactive marketing space since 1994. He leads interactive strategy globally for Wieden+Kennedy and is the co-founder and leader of W+K’s Portland Incubator Experiment (PIE), a technology business accelerator positioned at the intersection of startups and brands. Renny has presented on the stage at “Big TED” and is an original board member, speaker coach and chief advisor to TEDxPortland, he is vital to making each year’s event feel cohesive and impactful.
 `,
    },

}



export const list = Object.keys(dictionary)
